class UserInfo {
  constructor(data) {
    if (data === null) {
      this.id = -1;
      this.Name = null;
      this.PhoneNumber = null;
      this.Email = null;
      this.Password = null;
      this.CreatedByUserId = null;
      this.IsAdmin = false;
    } else {
      this.id = data.id;
      this.Name = data.Name;
      this.PhoneNumber = data.PhoneNumber;
      this.Email = data.Email;
      this.Password = data.Password;
      this.CreatedByUserId = data.CreatedByUserId;
      this.IsAdmin = data.IsAdmin;
    }
  }
}

export default UserInfo;
